const colors = [
  "#FF6384",
  "#36A2EB",
  "#FFCE56",
  "#4BC0C0",
  "#9966FF",
  "#FF9F40",
  "#024CAA",
  "#37AFE1",
  "#3C552D",
  "#CB9DF0",
  "#F0C1E1",
  "#FFE31A",
  "#C5D3E8",
  "#F95454",
  "#740938",
  "#AF1740",
  "#CC2B52",
  "#EC8305",
  "#00FF9C",
];
const whiteColors = [
  "#FF6384", // Açık kırmızı
  "#36A2EB", // Açık mavi
  "#FFCE56", // Açık sarı
  "#4BC0C0", // Açık yeşil
  "#FF9F40", // Açık turuncu
  "#F0C1E1", // Açık pembe
  "#FFE31A", // Sarı
  "#C5D3E8", // Soluk mavi
  "#F95454", // Açık kırmızı
  "#AF1740", // Koyu renk, çıkarttım
  "#CC2B52", // Koyu renk, çıkarttım
  "#EC8305", // Koyu renk, çıkarttım
  "#00FF9C", // Açık yeşil
  "#A0D1D6", // Ekstra açık mavi
  "#FFC3A0", // Ekstra açık pembe
  "#E5E5E5", // Açık gri
];
// const a = ["#003f5c", "#58508d", "#bc5090", "#ff6361", "#ffa600"];

export function getRandomColor() {
  const randomIndex = Math.floor(Math.random() * colors.length);
  return colors[randomIndex];
}
export function getRandomWhiteColor() {
  const randomIndex = Math.floor(Math.random() * whiteColors.length);
  return whiteColors[randomIndex];
}
